import { render, staticRenderFns } from "./DownloadAppModal.vue?vue&type=template&id=db484fd0&scoped=true"
import script from "./DownloadAppModal.vue?vue&type=script&lang=js"
export * from "./DownloadAppModal.vue?vue&type=script&lang=js"
import style0 from "./DownloadAppModal.vue?vue&type=style&index=0&id=db484fd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db484fd0",
  null
  
)

export default component.exports